import { ValidatorFn, AbstractControl, ValidationErrors, FormControl } from '@angular/forms';
//import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { FloatingCranesRequestService } from '../services/floating-cranes-request.service';

export class CustomValidators {
  static SailingdateValidator(selectedVesselTypeID: Number): ValidatorFn {

    return (control: AbstractControl): { [key: string]: boolean } | null => {

      if (selectedVesselTypeID == 31) {
        return null;
      } else {
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth()
        var day = date.getUTCDate();
        var todayDate = new Date(year, month, day);
        var enteredValue = control.value;
        var enteredDate = new Date(enteredValue);
        var dateString = enteredDate.toLocaleString('en-US').split(',')[0]
        var enteredDateByUser = new Date(dateString);
        if (enteredDateByUser < new Date(todayDate.toLocaleString('en-US'))) {
          return { inValidSailingDateError: true };
        }
        return null;
      }
    }

  }

  static dateValidator(): ValidatorFn {

    return (control: AbstractControl): { [key: string]: boolean } | null => {

      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth()
      var day = date.getUTCDate();
      var todayDate = new Date(year, month, day);

      var enteredValue = control.value;
      var enteredDate = new Date(enteredValue);
      var dateString = enteredDate.toLocaleString('en-US').split(',')[0]
      var enteredDateByUser = new Date(dateString);
      if (enteredDateByUser < new Date(todayDate.toLocaleString('en-US'))) {
        return { inValidDateError: true };
      }
      return null;
    }
  }

  static pastDateValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth()
      var day = date.getUTCDate();
      var todayDate = new Date(year, month, day);

      var enteredValue = control.value;
      var enteredDate = new Date(enteredValue);
      var dateString = enteredDate.toLocaleString('en-US').split(',')[0]
      var enteredDateByUser = new Date(dateString);
      if (enteredDateByUser > new Date(todayDate.toLocaleString('en-US'))) {
        return { inValidDateError: true };
      }
      return null;
    }
  }

  static textSpaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      var val = control.value;
      if (control.value != null) {
        if (control.value.startsWith(" ")) {
          return { startsWithSpaceError: true };
        }
      }
      return null;
    };
  }
  static SeventyThreeDaysRole(): ValidatorFn {

    return (control: AbstractControl): { [key: string]: boolean } | null => {

      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth()
      var day = date.getUTCDate();
      var todayDate = new Date(year, month, day);

      var enteredValue = control.value;
      var enteredDate = new Date(enteredValue);
      var dateString = enteredDate.toLocaleString('en-US').split(',')[0]
      var enteredDateByUser = new Date(dateString);
      var Difference_In_Time = enteredDateByUser.getTime() - todayDate.getTime();
      var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
      if (control.value != null) {
        if (Difference_In_Days >= 73) {
          return { SeventyThreeDaysRoleError: true };
        }
      }
      return null;
    };
  }

  static NextTwoDaysDateValidator(dateToSelectRequestExecutingDate: Date): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      var enteredValue = control.value;
      var enteredDate = new Date(enteredValue);
      var dateString = enteredDate.toLocaleString().split(',')[0]
      var enteredDateByUser = new Date(dateString);
      if (enteredDateByUser < dateToSelectRequestExecutingDate) {
        return { dateExceededNextTwoDaysError: true };
      }
      return null;
    }
  }

}



